import LoadIndicator from "components/LoadIndicator";
import styles from "./styles.module.css";
import CardTable from "components/CardTable";
import { useReportUnitListController } from "hooks/useReportUnitListController";
import { useEffect } from "react";

const columns = [
  {
    title: "Model",
    key: "model_name_des",
    getData: (val) => `${val.model_name_des}, ${val.model_code}`,
  },
  {
    title: "Unit Count",
    key: "unitCount",
  },
];

const ReportUnitList = () => {
  const {
    fetching,
    brand,
    list: data,
    triggerFetch,
    reset,
  } = useReportUnitListController();

  useEffect(() => {
    return reset;
  }, []);

  return (
    <div id="main-container" className={styles.unitList}>
      <div className="container">
        <h2 className="mb-4 userLevel-Title">Unit List</h2>

        <div className="row">
          <div className="col-12">
            <div className="mb-4">
              <div className="row ps-2 mb-3">
                <div className={`${styles.topLabel} col-4 col-md-2`}>
                  <span>Brand</span>
                </div>

                <div className={`${styles.label} col my-auto`}>
                  <span>{brand}</span>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <a href="#" className={styles.refresh} onClick={triggerFetch}>
                Refresh
              </a>
            </div>

            <div className="mb-4">
              <div className={`${styles.subtitle} mb-3`}>
                Close or Select original browser tab to return
              </div>

              {fetching ? (
                <LoadIndicator />
              ) : (
                <CardTable
                  id={"unit-list"}
                  customClassName={styles.dataTable}
                  columns={columns}
                  data={data}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportUnitList;
